import { useParams } from "react-router";
import { post } from '@aws-amplify/api';
import { useEffect, useRef, useState } from "react";
import { BackSyncedData } from "../contexts/DBDataSync";
import { Trophy, TrendingUp, Users, Star, Award, Share, Download, Brain, Zap, ChevronRight, Cloud, MessageCircle, Tag, Sparkles, Info, Eye, Heart, QrCode, ShareIcon, PieChart, Shield, Clock, Flame, GraduationCap, MapPin, Briefcase } from 'lucide-react';
import { ReputationMoreModal } from "../modals/ReputationMoreModal";
import { Skeleton } from "@mui/material";

function timeSince(dateString) {
    const pastTime = new Date(dateString).getTime();
    const now = Date.now();
    const diffMs = now - pastTime;

    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (days < 31) {
        return `${days} day${days !== 1 ? "s" : ""}`;
    }

    const months = Math.floor(days / 30);
    if (months < 12) {
        return `${months} month${months !== 1 ? "s" : ""}`;
    }

    const years = Math.floor(months / 12);
    return `${years} year${years !== 1 ? "s" : ""}`;
}
function RandomCol(i) {
    const colors = [
        '#9333EA',
        '#FF6B6B',
        '#4ECDC4',
        '#FFA726',
        '#06B6D4',
        '#F59E0B',
        '#10B981',
        '#8B5CF6',
    ];
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    
    return i==null? randomColor : colors[i];
}
function GetOrdinal(n) {
    const num = parseInt(n || 1)
    const suffixes = ["th", "st", "nd", "rd"];
    const v = num % 100;

    if (v >= 11 && v <= 13) {
        return num + "th";
    }

    return num + (suffixes[num % 10] || "th") + " Year";
}
const wordCloudTags = [
    { text: 'Chat First', size: 24, color: '#9333EA', votes: 0 },
    { text: 'Get Tags', size: 20, color: '#4ECDC4', votes: 0 },
    { text: 'Build Rep', size: 18, color: '#FF6B6B', votes: 0 },
    { text: 'Connect', size: 16, color: '#10B981', votes: 0 }
];

const MoreDataModal = ({ data, renderType, extraData, region }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <div
                onClick={() => {
                    setOpen(true);
                }}
                style={styles.moreButton}
            >
                <span style={styles.moreText}>more</span>
                <ChevronRight size="16px" color="rgba(255, 255, 255, 0.8)" />
            </div>
            <ReputationMoreModal
                visible={open}
                handleClose={() => setOpen(false)}
                data={data}
                renderType={renderType}
                extraData={extraData}
                region={region}
            />
        </>
    );
};

const HeaderRender = ({ userData }) => {
    return (
        <div style={styles.header}>
            <div style={styles.headerTop}>
                <div style={styles.headerLeft}>
                    <h1 style={styles.headerTitle}>Reputation</h1>
                    <p style={styles.headerSubtitle}>{`${userData?.name}'s`} complete Shink journey</p>
                </div>
            </div>
        </div>
    );
};

const AIProfileCard = ({ userData, filterSkill, filterPersonality }) => {
    const [showFullText, setShowFullText] = useState(false);
    const text = userData.profileDescription || 'Placeholder description.';
    const [isTextTruncated, setIsTextTruncated] = useState(false);
    const pRef = useRef(null);

    useEffect(() => {
        if (pRef.current) {
            setTimeout(() => {
                if (pRef.current.scrollHeight > pRef.current.clientHeight) {
                    setIsTextTruncated(true);
                } else {
                    setIsTextTruncated(false);
                }
            }, 0);
        }
    }, [text]);

    return (
        <div style={styles.aiProfileCard}>
            <div style={styles.aiProfileHeader}>
                <div style={{ display: 'flex',flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                    {/* Assuming Brain component is a web-compatible SVG or icon component */}
                    <Brain size="23px" color="#9333EA" />
                    <span style={styles.aiProfileTitle}>AI-Generated Profile</span>
                </div>
                <div style={styles.statBadge}>
                    {/* Assuming Eye component is a web-compatible SVG or icon component */}
                    <Eye size="14px" color="#4ECDC4" />
                    <span style={styles.statBadgeText}>{userData?.profileViews || '0'}</span>
                </div>
            </div>
            <div style={styles.aiProfileInfo}>
                <span style={styles.aiProfileSubtitle}>{userData?.reputationWord}</span>
                <div>
                    <p
                        ref={pRef}
                        style={{
                            ...styles.aiProfileDescription,
                            WebkitLineClamp: showFullText ? 'unset' : 3,
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                        }}
                    >
                        {text}
                    </p>
                    {isTextTruncated && (
                        <div onClick={() => setShowFullText(!showFullText)} style={styles.showMoreText}>
                            {showFullText ? 'Show less' : 'Show more'}
                        </div>
                    )}
                </div>
            </div>

            <div style={styles.topTagsContainer}>
                <span style={styles.topTagsTitle}>Top Recognition Areas</span>
                {filterSkill?.length > 0 && (
                    <div style={styles.topTagItem}>
                        <div style={styles.topTagRank}>
                            <span style={styles.topTagRankText}>#1</span>
                        </div>
                        <div style={styles.topTagInfo}>
                            <span style={styles.topTagName}>{filterSkill[0]?.tagName}</span>
                            <span style={styles.topTagCount}>
                                {filterSkill[0]?.count} mention{filterSkill[0]?.count > 1 ? 's' : ''} • Top {filterSkill[0]?.percentileGlobal} %
                            </span>
                        </div>
                    </div>
                )}
                {filterPersonality?.length > 0 && (
                    <div style={styles.topTagItem}>
                        <div style={styles.topTagRank}>
                            <span style={styles.topTagRankText}>#2</span>
                        </div>
                        <div style={styles.topTagInfo}>
                            <span style={styles.topTagName}>{filterPersonality[0]?.tagName}</span>
                            <span style={styles.topTagCount}>
                                {filterPersonality[0]?.count} mention{filterPersonality[0]?.count > 1 ? 's' : ''} • Top {filterPersonality[0]?.percentileGlobal} %
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const OverAllReputation = ({ userData }) => {
    return (
        <div style={styles.scoreCard}>
            <div style={styles.scoreHeader}>
                {/* LinearGradient can be replaced with a CSS gradient */}
                <div
                    style={{
                        ...styles.scoreIcon,
                        background: 'linear-gradient(to bottom, #FFD700, #FFA000)',
                    }}
                >
                    <Trophy size="32px" color="#fff" />
                </div>
                <div style={styles.scoreInfo}>
                    <span style={styles.scoreTitle}>Overall Reputation</span>
                    <span style={styles.scoreValue}>{userData?.reputationWord}</span>
                </div>
            </div>

            <div style={styles.contributionStats}>
                <div style={styles.contributionItem}>
                    <MessageCircle size="15px" color="#4ECDC4" />
                    <span style={styles.contributionNumber}>{userData?.totalComments?.toString() || '0'}</span>
                    <span style={styles.contributionLabel}>Comments</span>
                </div>
                <div style={styles.contributionItem}>
                    <Clock size="15px" color="#FF6B6B" />
                    <span style={styles.contributionNumber}>{timeSince(userData?.createdAt)}</span>
                    <span style={styles.contributionLabel}>Profile Age</span>
                </div>
                <div style={styles.contributionItem}>
                    <Users size="15px" color="#10B981" />
                    <span style={styles.contributionNumber}>{(userData?.connected?.length - 1) || '0'}</span>
                    <span style={styles.contributionLabel}>Connections</span>
                </div>
                <div style={styles.contributionItem}>
                    <Flame size="15px" color="#f53a0bff" />
                    <span style={styles.contributionNumber}>{Math.trunc(userData?.experiencePoints || 0)}</span>
                    <span style={styles.contributionLabel}>Total XP</span>
                </div>
            </div>
        </div>
    );
};

const TagAnalysisRender = ({ userData, filteredTags }) => {
    const [validation, setValidation] = useState([]);
    const [score, setScore] = useState(99)

    const categoryCounts = filteredTags?.reduce((acc, tagObj) => {
        const category = tagObj.category;
        acc[category] = (acc[category] || 0) + 1;
        return acc;
    }, {});

    const getUserData = async () => {
        try {
            const userId = userData.userId || ''
            const response = await post({
                apiName: 'FetchUserDataRedisAPI',
                path: '/',
                options: {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: { userId, reqType: 'validation' },
                },
            }).response;
            const resJson = await response.body.json() || [];

            const allTags = resJson.flatMap(userObj => {
                const userId = Object.keys(userObj)[0];
                return userObj[userId];
            });

            setValidation(allTags);
            const avgConfidence =
                allTags.length > 0
                    ? allTags.reduce((sum, obj) => sum + obj.confidence, 0) / allTags.length
                    : 0;
            setScore(avgConfidence);
        } catch (error) {
            console.log("Get Reputation Data: ", error);
        }
    };

    useEffect(() => {
        getUserData();
    }, []);

    return (
        <div style={styles.scoreCard}>
            <div style={styles.tagAnalysisHeader}>
                <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                    <PieChart size="18px" color="#9333EA" />
                    <span style={styles.cardTitle}>Tag Analysis</span>
                </div>
                <div style={styles.aiVerificationBadge}>
                    <Brain size="13px" color="#0de49cff" />
                    <span style={styles.aiVerificationText}>AI Verified</span>
                </div>
            </div>

            {/* AI Verification Overview */}
            <div style={styles.aiVerificationSection}>
                <div style={styles.aiScoreContainer}>
                    <span style={styles.aiScoreLabel}>AI Verification Score</span>
                    <div style={styles.aiScoreBar}>
                        <div
                            style={{
                                ...styles.aiScoreProgress,
                                width: `${score}%`,
                                background: 'linear-gradient(to right, #10B981, #059669)',
                            }}
                        />
                    </div>
                    <span style={styles.aiScoreValue}>{score}% Verified</span>
                </div>
                {/* <p style={styles.aiAnalysisNote}>
                    Based on analysis of 156 conversations and 89 interactions
                </p> */}
            </div>

            {/* Trust Score */}
            {/*<div style={styles.trustScoreSection}>
                <div style={styles.trustScoreHeader}>
                    <Shield size="15px" color="#0de49cff" />
                    <span style={styles.trustScoreTitle}>Trust Score: 98%</span>
                </div>
                <div style={styles.trustMetrics}>
                    <div style={styles.trustMetric}>
                        <span style={styles.trustMetricLabel}>Gaming Risk</span>
                        <span style={styles.trustMetricValue}>Low</span>
                    </div>
                    <div style={styles.trustMetric}>
                        <span style={styles.trustMetricLabel}>Flagged Interactions</span>
                        <span style={styles.trustMetricValue}>0</span>
                    </div>
                </div>
            </div>*/}

            <div style={styles.tagAnalysisGrid}>
                <div style={styles.tagAnalysisItem}>
                    <span style={styles.tagAnalysisNumber}>{userData?.receivedTagsCount || '0'}</span>
                    <span style={styles.tagAnalysisLabel}>Tags Received</span>
                </div>
                <div style={styles.tagAnalysisItem}>
                    <span style={styles.tagAnalysisNumber}>{userData?.givenTagsCount || '0'}</span>
                    <span style={styles.tagAnalysisLabel}>Tags Given</span>
                </div>
            </div>

            {/* Detailed Tag Verification */}
            <div style={styles.tagVerificationSection}>
                <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={styles.tagVerificationTitle}>Tag Verification Details</span>
                    {validation?.length > 3 && (
                        <MoreDataModal data={validation} renderType={'validation'} extraData={userData?.tagsCount} />
                    )}
                </div>
                <div style={styles.verifiedTagsList}>
                    {validation
                        ?.slice(0, 3)
                        .map((tag, index) => (
                            <div key={index} style={styles.verifiedTagItem}>
                                <div style={styles.verifiedTagHeader}>
                                    <span style={styles.verifiedTagName}>{tag?.tag}</span>
                                </div>
                                <div style={styles.tagMetrics}>
                                    <div style={styles.tagMetric}>
                                        <span style={styles.tagMetricLabel}>User Votes</span>
                                        <span style={styles.tagMetricValue}>{userData?.tagsCount?.[tag.tag?.replace(/\s/g, '').toLowerCase()] || '0'}</span>
                                    </div>
                                    <div style={styles.tagMetric}>
                                        <span style={styles.tagMetricLabel}>AI Score</span>
                                        <span style={styles.tagMetricValue}>{tag?.confidence}</span>
                                    </div>
                                    <div style={styles.tagMetric}>
                                        <span style={styles.tagMetricLabel}>Chat Examples</span>
                                        <span style={styles.tagMetricValue}>{tag?.example || '0'}</span>
                                    </div>
                                </div>
                                <div style={styles.aiEvidenceSection}>
                                    <span style={styles.aiEvidenceTitle}>AI Evidence:</span>
                                    <p style={styles.aiEvidenceText}>
                                        {tag?.evidence || 'AI evidence has been kept hidden from public view'}
                                    </p>
                                </div>
                            </div>
                        ))}
                </div>
            </div>

            <div style={styles.tagCategoryBreakdown}>
                <span style={styles.tagCategoryTitle}>Tags by Category</span>
                <div style={styles.tagCategoryItems}>
                    <div style={styles.tagCategoryItem}>
                        <div style={{ ...styles.tagCategoryIndicator, backgroundColor: '#4ECDC4' }} />
                        <span style={styles.tagCategoryName}>Skills {categoryCounts['Skills'] || '0'}</span>
                    </div>
                    <div style={{...styles.tagCategoryItem, marginTop: '2px'}}>
                        <div style={{ ...styles.tagCategoryIndicator, backgroundColor: '#9333EA' }} />
                        <span style={styles.tagCategoryName}>Personality {categoryCounts['Traits'] || '0'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TagsRender = ({ data, label, extra }) => {
    return (
        <div style={styles.categoriesCard}>
            <div style={styles.sectionHeader}>
                <span style={styles.cardTitle}>{label}</span>
                {data?.length > 3 && (
                    <MoreDataModal data={data} renderType={'tagFull'} region={extra} />
                )}
            </div>
            <div style={styles.categoriesGrid}>
                {data?.slice(0, 3).map((tag, index) => (
                    <div key={index} style={styles.categoryItem}>
                        <div style={{ ...styles.categoryIndicator, backgroundColor: RandomCol(index) }} />
                        <div style={styles.categoryInfo}>
                            <span style={styles.categoryName}>{tag?.tagName}</span>
                            <span style={styles.categoryScore}>
                                {tag?.count} mention{tag?.count > 1 ? 's' : ''}
                            </span>
                            {tag?.percentileCity && (
                                <span style={{...styles.categoryPercentile, color: label.includes("Skill") ? "#4ECDC4" : "#C084FC"}}>{extra?.city} Top {tag?.percentileCity} %</span>
                            )}
                            {tag?.percentileState && (
                                <span style={{...styles.categoryPercentile, color: label.includes("Skill") ? "#4ECDC4" : "#C084FC"}}>{extra?.state} Top {tag?.percentileState} %</span>
                            )}
                            {tag?.percentileCountry && (
                                <span style={{...styles.categoryPercentile, color: label.includes("Skill") ? "#4ECDC4" : "#C084FC"}}>{extra?.country} Top {tag?.percentileCountry} %</span>
                            )}
                            {tag?.percentileGlobal && (
                                <span style={{...styles.categoryPercentile, color: label.includes("Skill") ? "#4ECDC4" : "#C084FC"}}>🌍 Top {tag?.percentileGlobal} %</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const MilestonesRender = ({ userData }) => {
    const formatMilestoneName = (name = "") => {
        return name
            .toLowerCase()
            .replace(/[^a-z]/g, "");
    };

    const formatMonthYear = (timestamp) => {
        const date = new Date(timestamp);
        const month = date.toLocaleString('en-US', { month: 'short' }).toLowerCase();
        const year = date.getFullYear();
        return `${month} ${year}`;
    };

    return (
        <div style={styles.timelineCard}>
            <div style={styles.sectionHeader}>
                <span style={styles.cardTitle}>Reputation Milestones</span>
                {userData?.milestones?.length > 3 && (
                    <MoreDataModal data={userData?.milestones} renderType={'milestone'} />
                )}
            </div>
            <div style={styles.timeline}>
                {userData?.milestones
                    ?.slice(0, 3)
                    .map((milestone, index) => (
                        <div key={index} style={styles.timelineItem}>
                            <div style={styles.timelineIcon}>
                                <img
                                    style={{ width: "100%", height: "100%", objectFit: 'cover' }}
                                    src={`https://d2902n7npbzg1t.cloudfront.net/resources/${formatMilestoneName(milestone?.name)}.png`}
                                    alt={milestone?.name}
                                />
                            </div>
                            <div style={styles.timelineContent}>
                                <span style={styles.timelineTitle}>{milestone?.name}</span>
                                <span style={styles.timelineDate}>{formatMonthYear(milestone?.date)}</span>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

const TagCloud = ({ filteredTags }) => {
    return (
        <div style={styles.wordCloudCard}>
            <div style={styles.wordCloudHeader}>
                <Cloud size="20px" color="#fff" />
                <span style={styles.cardTitle}>Your Tag Cloud</span>
            </div>
            <p style={styles.wordCloudSubtitle}>
                Top tags from personality traits, reputation breakdown, and skills you can help with
            </p>
            <div style={styles.wordCloudContainer}>
                {filteredTags.length !== 0 ? (
                    filteredTags.map((tag, index) => (
                        <div
                            key={index}
                            style={{
                                ...styles.wordCloudTag,
                                transform: `rotate(${(index % 3 - 1) * 15}deg) scale(1)`,
                            }}
                        >
                            <span
                                style={{
                                    ...styles.wordCloudText,
                                    fontSize: `${Math.min(Math.max(tag.count, 8), 20)}px`,
                                    color: RandomCol(),
                                }}
                            >
                                {tag.tagName}
                            </span>
                            <span style={styles.wordCloudVotes}>{tag.count} votes</span>
                        </div>
                    ))
                ) : (
                    wordCloudTags.map((tag, index) => (
                        <div
                            key={index}
                            style={{
                                ...styles.wordCloudTag,
                                transform: `rotate(${(index % 3 - 1) * 15}deg) scale(1)`,
                            }}
                        >
                            <span
                                style={{
                                    ...styles.wordCloudText,
                                    fontSize: `${Math.min(Math.max(tag.votes, 8), 20)}px`,
                                    color: RandomCol(),
                                }}
                            >
                                {tag.text}
                            </span>
                            <span style={styles.wordCloudVotes}>{tag.votes} votes</span>
                        </div>
                    ))
                )}
            </div>
        </div>
    )
}

const ProfileCard = ({ userData }) => {
    const [showFullText, setShowFullText] = useState(false);
    const text = userData.bio;
    const [isTextTruncated, setIsTextTruncated] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        if (textRef.current) {
            const lineHeight = parseFloat(getComputedStyle(textRef.current).lineHeight) || 17;
            const maxHeight = lineHeight * 3;
            if (textRef.current.scrollHeight > maxHeight) {
                setIsTextTruncated(true);
            } else {
                setIsTextTruncated(false);
            }
        }
    }, [text]);

    return (
        <div style={styles.profileCard}>
            <div>
                <img
                    src={
                        userData?.images?.length > 0
                        ? userData.images[0].original
                        : '/appIcon.png'
                    }
                    style={styles.profileAvatar}
                    alt="Profile"
                />
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <span style={styles.profileName}>{userData?.name}</span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', width: '98%', textAlign: 'left', }}>
                {(userData?.collegeYear || userData.collegeStream) && (
                    <div style={styles.detailItem}>
                        <GraduationCap size={14} color="rgba(255, 255, 255, 0.8)" style={{marginRight: '5px'}} />
                        <span style={{ ...styles.profileDetails, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {userData?.collegeYear && GetOrdinal(userData.collegeYear)}{userData.collegeYear && userData.collegeStream && " • "}
                            {userData.collegeStream}
                        </span>
                    </div>
                )}
                {userData.collegeName && (
                    <div style={styles.detailItem}>
                        <MapPin size={14} color="rgba(255, 255, 255, 0.8)" style={{marginRight: '5px'}} />
                        <span style={styles.detailText}>{userData.collegeName}</span>
                    </div>
                )}
                {(userData?.jobTitle || userData?.jobDepartment) && (
                    <div style={styles.detailItem}>
                        <Briefcase size={14} color="rgba(255, 255, 255, 0.8)" style={{marginRight: '5px'}} />
                        <span style={{ ...styles.profileDetails, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            <span style={styles.profileDetails}>{userData?.jobTitle || userData?.jobDepartment}
                                {userData?.companyName && (userData?.jobTitle || userData?.jobDepartment) ? ' • ' : ''}{userData?.companyName}
                                {userData?.yearOfExperience && (
                                    <span>{' • '}{userData?.yearOfExperience} {userData?.yearOfExperience > 1 ? "Years" : "Year"} Experience</span>
                                )}
                            </span>
                        </span>
                    </div>
                )}
            </div>

            {userData?.bio?.length > 0 && (
                <div style={{ width: '100%', textAlign: 'left' }}>
                    <p
                        ref={textRef}
                        style={{
                            ...styles.bioText,
                            WebkitLineClamp: showFullText ? 'unset' : 3,
                            WebkitBoxOrient: 'vertical',
                            display: '-webkit-box',
                            overflow: 'hidden',
                        }}
                    >
                        {text}
                    </p>

                    {isTextTruncated && (
                        <div onClick={() => setShowFullText(!showFullText)} style={styles.showMoreText}>
                            <span>
                                {showFullText ? 'Show less' : 'Show more'}
                            </span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const ReputationPageView = ({ userData, viewedBy }) => {
    const { TagsData } = BackSyncedData();
    const [filteredTags, setFilteredTags] = useState([]);
    const Visibility = userData.reputationVisibility

    const processTags = async () => {
        const sortedEntries = Object.entries(userData?.tagsCount || {});
        const arr1Map = new Map(TagsData?.map(obj => [obj.id, obj]));
        const newJoinedArray = sortedEntries?.map(([id, value]) => {
            const originalObject = arr1Map?.get(id);

            if (!originalObject || value === 0) return null;
            const globalVal = userData?.tagPercent?.[id];

            if (globalVal == null) return null;
            const newObj = {
                ...originalObject,
                percentileGlobal: (100 - globalVal).toFixed(2),
                count: value
            }
            const countryVal = userData?.tagPercentCountry?.[id];
            if (countryVal != null) {
                newObj.percentileCountry = (100 - countryVal).toFixed(2);
            }

            const stateVal = userData?.tagPercentState?.[id];
            if (stateVal != null) {
                newObj.percentileState = (100 - stateVal).toFixed(2);
            }

            const cityVal = userData?.tagPercentCity?.[id];
            if (cityVal != null) {
                newObj.percentileCity = (100 - cityVal).toFixed(2);
            }
            return newObj;
        }).filter(Boolean); 
        setFilteredTags(newJoinedArray);
    };
    const filterSkill = filteredTags?.filter(item => item?.category?.includes("Skills"));
    const filterPersonality = filteredTags?.filter(item => item?.category?.includes("Traits"));

    useEffect(() => {
        processTags()
    }, [userData])
    
    return(
        <div style={styles.container}>
            <HeaderRender userData={userData} viewedBy={viewedBy} />
            <div 
                style={styles.scrollView}
            >
                <div style={styles.scrollContent}>
                    <ProfileCard userData={userData} />
                    {
                        Visibility?.aiCard?.BOOL &&
                        <AIProfileCard userData={userData} filterSkill={filterSkill} filterPersonality={filterPersonality} />
                    }

                    {
                        Visibility?.overallCard?.BOOL &&
                        <OverAllReputation userData={userData} />
                    }

                    {
                        Visibility?.analysisCard?.BOOL &&
                        <TagAnalysisRender userData={userData} filteredTags={filteredTags} />
                    }

                    {
                        Visibility?.skillCard?.BOOL &&
                        <TagsRender data={filterSkill} label={'Skill Breakdown'}
                        extra={{city: userData?.city, state: userData?.state, country: userData?.country}} />
                    }

                    {
                        Visibility?.traitCard?.BOOL &&
                        <TagsRender data={filterPersonality} label={'Personality Traits'}
                        extra={{city: userData?.city, state: userData?.state, country: userData?.country}} />
                    }

                    {
                        userData.milestones && Visibility?.milestoneCard?.BOOL &&
                        <MilestonesRender userData={userData}/>
                    }

                    {
                        Visibility?.cloudCard?.BOOL &&
                        <TagCloud filteredTags ={filteredTags} />
                    }
                    <div style={{ height: '30px' }} />
                </div>
            </div>
        </div>
    )
}

const ReputationScreen = ({ profile }) => {
    const params = useParams();
    const profileId = profile || params.id;

    const [userData, setUserData] = useState([]);

    const getUserData = async() => {
        try {
            const response = await post({
                apiName: 'ShareProfileAPI',
                path: '/',
                options: {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: { profileId, reqType: 'getData' },
                },
            }).response;
            const resJson = await response.body.json();
            
            setUserData(resJson);
        } catch (error) {
            console.log("Get Reputation Data: ", error);
        }
    }

    useEffect(() => {
        getUserData();
    }, [])

    return userData.userId? (
        <ReputationPageView userData={userData} />
    ) : (
        <div style={styles.container}>
            <Skeleton variant="rectangular" animation="wave" width={'95%'} height={'95%'}
            sx={{ 
                alignSelf: 'center', 
                marginTop: '15px',
                bgcolor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '20px'
            }}  />
        </div>
    );
}

const styles = {
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: "column",
        backgroundImage: "linear-gradient(to bottom, #2C3E50, #3498DB, #9B59B6)",
        width: "100%",
        height: "100%",
    },
    header: {
        paddingTop: "0px",
        paddingBottom: "0px",
        paddingLeft: "8px",
    },
    headerTop: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
    },
    headerLeft: {
        flex: 1,
    },
    headerTitle: {
        fontSize: '26px',
        color: '#fff',
        textAlign: 'left',
    },
    headerSubtitle: {
        fontSize: '15px',
        color: 'rgba(255, 255, 255, 0.8)',
        textAlign: 'left',
    },
    headerRight: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '14px',
    },
    headerActions: {
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
    },
    actionButton: {
        padding: '6px',
        borderRadius: '2000px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    scrollView: {
        flex: 1,
        display: 'flex',
        overflowY: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    },
    scrollContent: {
        paddingLeft: '13px',
        paddingRight: '13px',
        paddingBottom: '10px',
    },
    aiProfileCard: {
        borderRadius: '18px',
        paddingLeft: '13px',
        paddingRight: '13px',
        paddingBottom: '10px',
        paddingTop: '10px',
        marginBottom: '10px',
        borderWidth: '2px',
        borderColor: 'rgba(147, 51, 234, 0.4)',
        overflow: 'hidden',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
    aiProfileHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '0px',
        justifyContent: 'space-between',
    },
    aiIcon: {
        width: '50px',
        height: '50px',
        borderRadius: '25px',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '16px',
    },
    aiProfileInfo: {
        textAlign: 'left'
    },
    aiProfileTitle: {
        fontSize: '18px',
        color: '#fff',
        marginBottom: '4px',
    },
    statBadge: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        paddingTop: '3px',
        paddingBottom: '3px',
        paddingLeft: '4px',
        paddingRight: '4px',
        borderRadius: '12px',
        gap: '5px',
    },
    statBadgeText: {
        fontSize: '11px',
        color: '#fff',
        fontWeight: '600',
    },
    aiProfileSubtitle: {
        fontSize: '15px',
        fontWeight: '600',
        color: '#C084FC',
        textAlign: 'left'
    },
    aiProfileDescription: {
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.8)',
        lineHeight: '16px',

    },
    showMoreText: {
        color: '#374bffff',
        textDecorationLine: 'underline',
        cursor: "pointer",
    },
    topTagsContainer: {
        marginBottom: '12px',
        marginTop: '5px',
        textAlign: 'left'
    },
    topTagsTitle: {
        fontSize: '14.5px',
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: '3px',
    },
    topTagItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        paddingTop: '5px',
        paddingBottom: '5px',
        paddingLeft: '8px',
        paddingRight: '8px',
        marginTop: '5px',
    },
    topTagRank: {
        width: '22px',
        height: '22px',
        borderRadius: '100px',
        backgroundColor: '#9333EA',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '10px',
        display: 'flex'
    },
    topTagRankText: {
        fontSize: '10px',
        fontWeight: 'bold',
        color: '#fff',
    },
    topTagInfo: {
        display: 'flex',
        flexDirection: 'column',
    },
    contributionStats: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        padding: '10px',
        marginBottom: '0px',
        marginTop: '8px',
    },
    contributionItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1px',
    },
    contributionNumber: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#fff',
    },
    contributionLabel: {
        fontSize: '9px',
        color: 'rgba(255, 255, 255, 0.7)',
        textAlign: 'center',
    },
    topTagName: {
        fontSize: '14.5px',
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: '0px',
    },
    topTagCount: {
        fontSize: '11px',
        color: '#C084FC',
        fontWeight: '600',
        marginBottom: '0px',
    },
    scoreCard: {
        borderRadius: '18px',
        paddingLeft: '13px',
        paddingRight: '13px',
        paddingBottom: '10px',
        paddingTop: '10px',
        marginBottom: '10px',
        borderWidth: '1px',
        borderColor: 'rgba(255, 255, 255, 0.4)',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        overflow: 'hidden',
    },
    scoreHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    scoreIcon: {
        width: '55px',
        height: '55px',
        display: 'flex',
        borderRadius: '1000px',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '15px',
    },
    scoreInfo: {
        flex: 1,
        textAlign: 'left'
    },
    scoreTitle: {
        fontSize: '15px',
        color: 'rgba(255, 255, 255, 0.8)',
        marginBottom: '2px',
        display: 'flex',
        flexDirection: 'column',
    },
    scoreValue: {
        fontSize: '22px',
        color: '#fff',
        marginBottom: '0px',
    },
    shareContainer: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        padding: '15px',
        marginBottom: '3px',
        marginTop: '8px',
    },
    shareText: {
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.8)',
        marginBottom: '11px',
        textAlign: 'center',
    },
    shareButton: {
        backgroundColor: 'rgba(255, 107, 107, 0.9)',
        paddingVertical: '9px',
        paddingHorizontal: '15px',
        borderRadius: '12px',
        gap: '5px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    shareButtonText: {
        color: '#fff',
        fontSize: '16px',
        fontWeight: '600',

    },
    shareButtons: {
        display: 'flex',
        flexDirection: 'row',
        gap: '11px',
        justifyContent: 'center',
    },
    qrButton: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgba(78, 205, 196, 0.9)',
        paddingVertical: '9px',
        paddingHorizontal: '15px',
        borderRadius: '10px',
        gap: '5px',
    },
    qrButtonText: {
        color: '#fff',
        fontSize: '13px',
        fontWeight: '600',
    },
    sectionHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px',
    },
    moreButton: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '2px',
        justifyContent: 'center',
        cursor: 'pointer'
    },
    moreText: {
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.8)',
        fontWeight: '500',
        marginBottom: '4px'
    },
    personalityGrid: {
        gap: '16px',
    },
    personalityItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    personalityInfo: {
        flex: 1,
    },
    personalityName: {
        fontSize: '15px',
        color: '#fff',
        fontWeight: '600',
        marginBottom: '2px',
    },
    personalityScore: {
        fontSize: '13px',
        color: '#C084FC',
        marginBottom: '2px',
    },
    personalityPercentile: {
        fontSize: '11px',
        color: '#C084FC',
        fontWeight: '600',
    },
    categoriesCard: {
        borderRadius: '15px',
        paddingLeft: '13px',
        paddingRight: '13px',
        paddingBottom: '10px',
        paddingTop: '10px',
        marginBottom: '10px',
        borderWidth: '1px',
        borderColor: 'rgba(255, 255, 255, 0.4)',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        overflow: 'hidden',
    },
    cardTitle: {
        fontSize: '16px',

        color: '#fff',

    },
    categoriesGrid: {
        gap: '5px',
    },
    categoryItem: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        textAlign: 'left',
        marginBottom: '5px',
    },
    categoryIndicator: {
        width: '4px',
        borderRadius: '2px',
        marginRight: '11px',
        alignSelf: "stretch",
        transform: "scaleY(0.8)",
        transformOrigin: "center",
    },
    categoryInfo: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    categoryName: {
        fontSize: '15px',
        color: '#fff',
        fontWeight: '600',
        marginBottom: '2px',
    },
    categoryScore: {
        fontSize: '13px',
        color: '#4ECDC4',
        marginBottom: '2px',
    },
    categoryPercentile: {
        fontSize: '11px',
        color: '#4ECDC4',
        fontWeight: '600',
    },
    timelineCard: {
        borderRadius: '15px',
        paddingLeft: '13px',
        paddingRight: '13px',
        paddingBottom: '8px',
        paddingTop: '10px',
        marginBottom: '10px',
        borderWidth: '1px',
        borderColor: 'rgba(255, 255, 255, 0.4)',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        overflow: 'hidden',
    },
    timeline: {
        gap: '5px',
    },
    timelineItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '6px'
    },
    timelineIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '1800px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '10px',
    },
    timelineEmoji: {
        fontSize: '16.5px',
        color: 'rgba(255, 255, 255, 0.7)',

    },
    timelineContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left'
    },
    timelineTitle: {
        fontSize: '15px',
        color: '#fff',
        fontWeight: '600',
        marginBottom: '2px',
    },
    timelineDate: {
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.6)',
    },
    timelineLine: {
        position: 'absolute',
        left: '18px',
        top: '43px',
        width: '2px',
        height: '18px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    wordCloudCard: {
        borderRadius: '15px',
        paddingLeft: '13px',
        paddingRight: '13px',
        paddingBottom: '10px',
        paddingTop: '10px',
        borderWidth: '1px',
        borderColor: 'rgba(255, 255, 255, 0.4)',
        overflow: 'hidden',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
    wordCloudHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '7px',
        marginBottom: '10px',
    },
    wordCloudSubtitle: {
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.7)',
        marginBottom: '10px',

        lineHeight: '17px',
    },
    wordCloudContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '15px',
    },
    wordCloudTag: {
        alignItems: 'center',
        margin: '7px',
        display: 'flex',
        flexDirection: 'column',
    },
    wordCloudText: {

        textAlign: 'center',
        marginBottom: '2px',
    },
    wordCloudVotes: {
        fontSize: '9px',
        color: 'rgba(255, 255, 255, 0.6)',

        textAlign: 'center',
    },
    content: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: '30px',
    },
    iconContainer: {
        position: 'relative',
        marginBottom: '36px',
        alignItems: 'center',
        justifyContent: 'center',
        width: '92px',
        height: '92px',
    },
    tagIcon: {
        position: 'absolute',
        top: '-8px',
        right: '-8px',
    },
    sparkleIcon: {
        position: 'absolute',
        bottom: '-5px',
        left: '-14px',
    },
    message: {
        fontSize: '16px',
        color: 'rgba(255, 255, 255, 0.9)',
        textAlign: 'center',

        lineHeight: '22px',
        fontWeight: '500',
    },
    tagAnalysisHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '10px',
        gap: '8px',
    },
    aiVerificationBadge: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgba(23, 248, 173, 0.2)',
        paddingLeft: '7px',
        paddingRight: '7px',
        paddingBottom: '3px',
        paddingTop: '3px',
        borderRadius: '12px',
        gap: '4px',
    },
    aiVerificationText: {
        fontSize: '11px',
        color: '#0de49cff',
        fontWeight: '600',
    },
    aiVerificationSection: {
        backgroundColor: 'rgba(23, 248, 173, 0.1)',
        borderRadius: '12px',
        padding: '10px',
        marginBottom: '10px',
        borderWidth: '1px',
        borderColor: 'rgba(23, 248, 173, 0.5)',
    },
    aiScoreContainer: {
        marginBottom: '0px',
    },
    aiScoreLabel: {
        fontSize: '13px',
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: '8px',
        textAlign: 'left', 
        display: 'block',
    },
    aiScoreBar: {
        height: '7px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '1000px',
        overflow: 'hidden',
        marginBottom: '5px',
    },
    aiScoreProgress: {
        height: '100%',
        borderRadius: '4px',
    },
    aiScoreValue: {
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#0de49cff',
        textAlign: 'center',
    },
    aiAnalysisNote: {
        fontSize: '11px',
        color: 'rgba(255, 255, 255, 0.8)',
        textAlign: 'center',
        fontStyle: 'italic',
        marginTop: '4px'
    },
    trustScoreSection: {
        backgroundColor: 'rgba(23, 248, 173, 0.1)',
        borderRadius: '12px',
        padding: '10px',
        marginBottom: '10px',
        borderWidth: '1px',
        borderColor: 'rgba(23, 248, 173, 0.5)',
    },
    trustScoreHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '7px',
        marginBottom: '7px',
    },
    trustScoreTitle: {
        fontSize: '14.5px',
        fontWeight: 'bold',
        color: '#0de49cff',
    },
    trustMetrics: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
    },
    trustMetric: {
        alignItems: 'center',
    },
    trustMetricLabel: {
        fontSize: '11px',
        color: 'rgba(255, 255, 255, 0.8)',
        marginBottom: '2px',
        flexDirection: 'column',
        display: 'flex'
    },
    trustMetricValue: {
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#0de49cff',
    },
    tagVerificationSection: {
        marginBottom: '10px',
    },
    tagVerificationTitle: {
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#fff',
    },
    verifiedTagsList: {
        gap: '8px',
    },
    verifiedTagItem: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingBottom: '10px',
        paddingTop: '10px',
        borderWidth: '1px',
        borderColor: 'rgba(255, 255, 255, 0.1)',
        marginBottom: '10px'
    },
    verifiedTagHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '6px',
    },
    verifiedTagName: {
        fontSize: '14.5px',
        fontWeight: 'bold',
        color: '#fff',
    },
    verificationBadges: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
    },
    veracityBadge: {
        paddingHorizontal: '8px',
        paddingVertical: '4px',
        borderRadius: '8px',
    },
    highlyVerified: {
        backgroundColor: 'rgba(16, 185, 129, 0.8)',
    },
    veracityBadgeText: {
        fontSize: '10px',
        color: '#fff',
        fontWeight: '600',
    },
    aiConfidence: {
        fontSize: '12px',
        color: '#10B981',
        fontWeight: '600',
    },
    tagMetrics: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginBottom: '6px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '10px',
        paddingBottom: '5px',
        paddingTop: '5px',
    },
    tagMetric: {
        alignItems: 'center',
        flexDirection: 'column',
        display: 'flex'
    },
    tagMetricLabel: {
        fontSize: '10px',
        color: 'rgba(255, 255, 255, 0.7)',
        marginBottom: '2px',
    },
    tagMetricValue: {
        fontSize: '13px',
        fontWeight: 'bold',
        color: '#fff',
    },
    aiEvidenceSection: {
        backgroundColor: 'rgba(147, 51, 234, 0.1)',
        borderRadius: '10px',
        paddingLeft: '8px',
        paddingRight: '8px',
        paddingBottom: '3px',
        paddingTop: '3px',
        borderWidth: '1px',
        borderColor: 'rgba(147, 51, 234, 0.3)',
        textAlign: 'left'
    },
    aiEvidenceTitle: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#C084FC',
    },
    aiEvidenceText: {
        fontSize: '11px',
        color: 'rgba(255, 255, 255, 0.8)',
        lineHeight: '13px',
    },
    gamingPreventionSection: {
        backgroundColor: 'rgba(245, 158, 11, 0.1)',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '16px',
        borderWidth: '1px',
        borderColor: 'rgba(245, 158, 11, 0.3)',
    },
    gamingPreventionTitle: {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#F59E0B',
        marginBottom: '12px',
    },
    gamingMetrics: {
        gap: '8px',
    },
    gamingMetric: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '8px',
        padding: '12px',
    },
    gamingMetricLabel: {
        fontSize: '12px',
        color: 'rgba(255, 255, 255, 0.8)',
        marginLeft: '8px',
        flex: 1,
    },
    gamingMetricValue: {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#fff',
    },
    tagAnalysisGrid: {
        display: 'flex',
        flexDirection: 'row',
        gap: '14px',
        marginBottom: '10px',
    },
    tagAnalysisItem: {
        flex: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        paddingBottom: '3px',
        paddingTop: '3px',
        alignItems: 'center',
        flexDirection: 'column',
        display: 'flex'
    },
    tagAnalysisNumber: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: '0px',
    },
    tagAnalysisLabel: {
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.8)',
        marginBottom: '4px',
    },
    tagAnalysisBreakdown: {
        alignItems: 'center',
    },
    tagAnalysisDetail: {
        fontSize: '10px',
        color: '#C084FC',
        textAlign: 'center',
    },
    tagCategoryBreakdown: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        paddingLeft: '8px',
        paddingRight: '8px',
        paddingBottom: '7px',
        paddingTop: '5px',
        marginBottom: '3px',
        textAlign: 'left'
    },
    tagCategoryTitle: {
        fontSize: '13px',
        fontWeight: 'bold',
        color: '#fff',
    },
    tagCategoryItems: {
        gap: '6px',
        marginTop: '6px'
    },
    tagCategoryItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '6px',
    },
    tagCategoryIndicator: {
        width: '11px',
        height: '11px',
        borderRadius: '1000px',
    },
    tagCategoryName: {
        fontSize: '11px',
        color: 'rgba(255, 255, 255, 0.8)',
    },
    profileCard: {
        borderRadius: '18px',
        padding: '10px',
        alignItems: 'center',
        borderWidth: '1px',
        borderColor: 'rgba(255, 255, 255, 0.4)',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        overflow: 'hidden',
        marginBottom: '10px'
    },
    levelContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '0',
        gap: '12px',
        width: '100%'
    },
    levelBadge: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 215, 0, 0.2)',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingTop: '5px',
        paddingBottom: '5px',
        borderRadius: '10000px',
        borderWidth: '1px',
        borderColor: 'rgba(255, 215, 0, 0.4)',
        gap: '4px',
    },
    levelText: {
        color: '#FFD700',
        fontSize: '13px',
        fontWeight: 'bold',
    },
    xpContainer: {
        flex: 1,
        alignItems: 'flex-end',
    },
    xpBar: {
        width: '52%',
        height: '7px',
        backgroundColor: 'rgba(255, 255, 255, 0.35)',
        borderRadius: '10000px',
        overflow: 'hidden',
        marginBottom: '3px',
    },
    xpProgress: {
        height: '100%',
        borderRadius: '10000px',
    },
    xpText: {
        fontSize: '11px',
        color: 'rgba(255, 255, 255, 0.8)',
        fontWeight: '600',
    },
    profileAvatar: {
        width: '93px',
        aspectRatio: '1',
        borderRadius: '10000px',
        borderWidth: '2px',
        borderColor: 'rgba(255, 255, 255, 0.5)',
        objectFit: 'cover'
    },
    profileName: {
        fontSize: '22px',
        color: '#fff',
        marginBottom: '2px',
    },
    profileDetails: {
        fontSize: '14px',
        color: 'rgba(255, 255, 255, 0.8)',
        marginBottom: '0',
        textAlign: 'center',
    },
    detailItem: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: '4px',
    },
    detailText: {
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.8)',
    },
    bioText: {
        fontSize: '14px',
        color: 'rgba(255, 255, 255, 0.8)',
        lineHeight: '17px',
        alignSelf: 'flex-start',
        marginTop: '7px',
        marginLeft: '5px',
    },
};

export default ReputationScreen;